import { render } from "./CompareQueueTable.vue?vue&type=template&id=07b2193e"
import script from "./CompareQueueTable.vue?vue&type=script&lang=js"
export * from "./CompareQueueTable.vue?vue&type=script&lang=js"

import "./CompareQueueTable.vue?vue&type=style&index=0&id=07b2193e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__